import React, { useState } from 'react'
import { Link } from "gatsby"
import * as classes from './navbar.module.scss'

import Container from '../container/container'
import ToggleMenu from '../togglemenu/togglemenu'
import LanguageSelector from '../languageselector/languageselector'

import logo from '../../assets/images/logos/logo_witteveen_bos.png'
import logo2x from '../../assets/images/logos/logo_witteveen_bos@2x.png'

export default function Navbar() {
    const [toggleMenuShow, setToggleMenuShow] = useState(false);

    return (
        <React.Fragment>
            <nav className={"navbar navbar-expand-lg " + classes.Navbar}>
                <Container>
                    <Link className="navbar-brand" to={"/"}>
                        <img src={logo} data-at2x={logo2x} alt="Witteveen+Bos" />
                    </Link>

                    <div className={"navbar text-right"}>
                        <div>
                            <LanguageSelector />
                            <ul className={"navbar-nav " + classes.NavbarMenu}>
                                <li className={"nav-item " + classes.NavItem}>
                                    <Link className={"nav-link " + classes.NavLink} to={"/"}>Home</Link>
                                </li>
                            </ul>

                            <i
                                aria-hidden="true" 
                                className={"icon-menu " + classes.HamburgerIcon}
                                onClick={() => setToggleMenuShow(!toggleMenuShow)}
                                onKeyDown={() => setToggleMenuShow(!toggleMenuShow)}></i>
                        </div>
                    </div>
                </Container>
            </nav>

            <ToggleMenu show={toggleMenuShow} toggle={() => setToggleMenuShow(!toggleMenuShow)} />
        </React.Fragment>
    )
}